const FontsWeightFoundationsZiniaThemes = {
    font_light: 300,
    font_regular: 400,
    font_weight_600: 600,
    font_bold: 700,
};
export { FontsWeightFoundationsZiniaThemes };
//# sourceMappingURL=fonts-weight-foundations.zinia.themes.js.map